import { colors } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import ThumbsDown from 'common/components/icons/ThumbsDown';
import ThumbsUp from 'common/components/icons/ThumbsUp';

const GreenThumbsUp = styled(ThumbsUp)`
  color: ${colors.lime100};
`;

const RedThumbsDown = styled(ThumbsDown)`
  color: ${colors.strawberry100};
`;
const ThumbsIcon = ({ positive }: { positive: boolean }) => {
  if (positive) {
    return <GreenThumbsUp />;
  } else {
    return <RedThumbsDown />;
  }
};

export default ThumbsIcon;
